import Intro from './0-intro.json';
import Remuneration from './1-remuneration.json';
import Titrisation from './2-titrisation.json';
import Titrisation2 from './2-titrisation2.json';
import Toobig from './3-toobig.json';
import Regulation from './4-regulation.json';
import Oligarchie from './5-oligarchie.json';

module.exports = {
    intro: Intro,
    remuneration: Remuneration,
    titrisation: Titrisation,
    titrisations: Titrisation2,
    regulation: Regulation,
    toobig: Toobig,
    oligarchie: Oligarchie,
};



// WEBPACK FOOTER //
// ./js/data/chapters/index.js